import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { CacheDemoResponse, ApiError } from '../types/showcase';

/**
 * Mutation: GET /api/eraf/showcase/cache?key=...
 * Using mutation (not query) so the user can manually trigger each call
 * and see the hit/miss difference.
 * First call: ~1500ms (cache miss). Second call: <50ms (cache hit).
 */
export function useCacheDemo() {
  return useMutation<CacheDemoResponse, ApiError, string>({
    mutationFn: (key) => showcaseApi.cache(key),
    mutationKey: ['common-showcase', 'cache'],
  });
}
